module.exports = __webpack_public_path__ + "img/1K2.28494803.png";